import { makeApiCall } from "../utils/request-util";
import { decodeToken } from "../utils/token-util";

export const fetchTenancyData = async (opts = {}) => {
    const token = sessionStorage.getItem("id_token");
    const { cidn } = decodeToken(token);

    const options = {
        ...opts,
        uri: "/account/v2/tenants",
        params: {
            cidn,
            ...opts.params,
        },
    };

    return await makeApiCall(options);
};

export const fetchActiveDevicesCount = async (tenancyId, opts) => {
    let options = {
        uri: `/inventory/v2/tenants/${tenancyId}/devices/count`,
        ...opts,
    };

    return await makeApiCall(options);
};
